
import type { Dictionary, RegularFilter } from '../../models'
import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'

import { defineComponent } from 'vue'

import Schedule from '../../components/crud/schedule.component.vue'
import { EpbKeywords } from '../../components/shared/epb-keywords'
import { EpbTextbox } from '../../components/shared/epb-textbox'
import ToolingFormLayout from '../../components/tooling/tooling-form-layout.component.vue'

import { FeatureIdEnum, PositionEnum } from '../../enums'

import { CrudFormMixin } from '../../mixins'

import { ROUTER_CONSTS } from '../../router/router.consts'

export default defineComponent({
  name: 'RedirectionsForm',
  components: {
    EpbTextbox,
    EpbKeywords,
    ToolingFormLayout,
    Schedule,
  },
  mixins: [CrudFormMixin],
  data() {
    return {
      dataType: ActionTypeEnum.REDIRECTION,
      updateMode: this.$route.name === ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].update,
      item: {
        enabled: true,
        keywords: [],
        url: '',
        filters: {
          lang: [],
        },
        schedule: {
          activationDate: null,
          deactivationDate: null,
        },
      },
      PositionEnum,
      messages: this.$epb.messages.tools.redirections,
    }
  },
  computed: {
    filters(): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)()
      filters.lang.config.mandatory = true
      return filters
    },
    valid(): boolean {
      if (!this.item.filters.lang.length) {
        return false
      }
      if (!this.item.keywords.length) {
        return false
      }
      if (!this.item.url) {
        return false
      }
      return true
    },
  },
})
